import { Heart } from "lucide-react";
import { useFavorites } from "@/lib/favorites";

export default function FavButton({ act, variant = "icon" }) {
  const { has, toggle } = useFavorites();
  const on = has(act.id);
  const label = on ? "Remover de A minha Feira" : "Adicionar a A minha Feira";
  const onClick = (e) => { e.preventDefault(); e.stopPropagation(); toggle(act); };
  if (variant === "full") {
    return (
      <button onClick={onClick} aria-pressed={on} data-testid="activity-fav-button"
        className={`inline-flex items-center gap-2 h-12 px-5 rounded-full font-semibold transition-colors ${on ? "bg-[var(--clay)] text-white" : "bg-white border-2 border-[var(--ink)] hover:bg-amber-50"}`}>
        <Heart className={`h-5 w-5 ${on ? "fill-current" : ""}`} aria-hidden />{on ? "Na minha Feira" : "Adicionar à minha Feira"}
      </button>
    );
  }
  return (
    <button onClick={onClick} aria-pressed={on} aria-label={label} title={label} data-testid={`fav-button-${act.slug}`}
      className={`h-11 w-11 grid place-items-center rounded-full transition-transform active:scale-90 ${on ? "bg-[var(--clay)] text-white" : "bg-white/95 text-[var(--ink)] hover:bg-amber-50 border border-black/10"}`}>
      <Heart className={`h-5 w-5 ${on ? "fill-current" : ""}`} aria-hidden />
    </button>
  );
}
